"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _AssetActivityDetails = _interopRequireDefault(require("../../components/AssetActivityDetails"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _MarginClosePositionModal = _interopRequireDefault(require("../../components/MarginClosePosition/MarginClosePositionModal"));
var _positionActions = require("../../redux/actions/positionActions");
var _marginSelectors = require("../../../lib/redux/margin/selectors/marginSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var classes = (0, _cssClassesHelper.getBEMClasses)('asset-activity-details-layout');
var BuySellDesktopLayout = function BuySellDesktopLayout(_ref) {
  var MarginBorrowerEnabled = _ref.MarginBorrowerEnabled,
    selectPositionAndSave = _ref.selectPositionAndSave;
  (0, _react.useEffect)(function () {
    selectPositionAndSave(null);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_AssetActivityDetails["default"], null)), MarginBorrowerEnabled && /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    MarginBorrowerEnabled: (0, _marginSelectors.marginBorrowerEnabledSelector)(state)
  };
};
var mapDispatchToProps = {
  selectPositionAndSave: _positionActions.selectPositionAndSave
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuySellDesktopLayout);